import React, { Suspense } from 'react';
import OrderItemRow from './components/OrderItemRow';
import Container from '~/App/components/Container';
import i18n from '~/i18n';
import Header from '../../../components/Header';
import { useNavigate } from 'react-router-dom';
import StickyHeader from '../../../components/StickyHeader';
import { OrderStatus, OrderType } from '@restaurant/types';
import { useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@restaurant/api';
import { Collapse, Empty } from 'antd';
import Loading from '~/App/components/Loading';
import ErrorBoundary from '~/App/ErrorBoundary';
import './style.css';

const ListOrderItems = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchOrderList'],
    queryFn: () => {
      return api.fetchOrderList({
        filter: {
          statuses: [OrderStatus.Open],
        },
      });
    },
    refetchOnMount: true,
    staleTime: 0,
    gcTime: 0,
  });

  const items = data.data;

  const content = (() => {
    if (!items?.length) {
      return (
        <div className="mt-[200px]">
          <Empty />
        </div>
      );
    }

    const normalItems = items
      .filter(({ orderType }) => orderType !== OrderType.Indent)
      .map((item) => <OrderItemRow order={item} key={item.orderId} />);
    const indentOrderItems = items
      .filter(({ orderType }) => orderType === OrderType.Indent)
      .map((item) => <OrderItemRow order={item} key={item.orderId} />);

    return (
      <>
        <Collapse className="list-order-indent">
          <Collapse.Panel
            key={'indent'}
            header={`Order Indent (${indentOrderItems.length})`}
          >
            {indentOrderItems}
            <div className="w-full bg-neutral-100 h-4" />
          </Collapse.Panel>
        </Collapse>
        {normalItems}
      </>
    );
  })();

  return (
    <div className="flex flex-col pb-[60px] relative flex-1">{content}</div>
  );
};

const ListOrder = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <StickyHeader>
        <Header
          title={i18n.t('list_order_page_header')}
          onBack={() => {
            navigate('/');
          }}
        />
      </StickyHeader>
      <ErrorBoundary>
        <Suspense fallback={<Loading className="bg-white/50 flex-1" />}>
          <ListOrderItems />
        </Suspense>
      </ErrorBoundary>
    </Container>
  );
};

export default ListOrder;
